import React from 'react';
import { appStoreUrlForLocation } from '../services/links';

export function AppStoreBadge({ href, location = 'site', style, size = 'default' }) {
  const width = size === 'small' ? 128 : 170;
  const destination = href || appStoreUrlForLocation(location);

  return (
    <a
      href={destination}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download Bhol on the App Store"
      data-analytics-click="app_store_click"
      data-analytics-label="App Store"
      data-analytics-location={location}
      style={{
        display: 'inline-flex',
        lineHeight: 0,
        borderRadius: 9,
        transition: 'transform 0.2s ease, filter 0.2s ease',
        ...style,
      }}
      onMouseEnter={(event) => {
        event.currentTarget.style.transform = 'translateY(-1px)';
        event.currentTarget.style.filter = 'brightness(1.08)';
      }}
      onMouseLeave={(event) => {
        event.currentTarget.style.transform = 'translateY(0)';
        event.currentTarget.style.filter = 'none';
      }}
    >
      <img
        src="/app-store-badge.svg"
        alt="Download on the App Store"
        width={width}
        height={Math.round(width / 3.37)}
        style={{ display: 'block', width, height: 'auto' }}
      />
    </a>
  );
}

export default AppStoreBadge;
